import { __decorate } from "tslib";
import { Injectable } from "@angular/core";
let LayerListComponent = class LayerListComponent {
    constructor() { }
    layerActions(event) {
        const item = event.item;
        item.actionsSections = [
            // [
            //   {
            //     title: "Go to full extent",
            //     className: "esri-icon-zoom-out-fixed",
            //     id: "full-extent"
            //   },
            // ],
            [
                {
                    title: "Increase opacity",
                    className: "esri-icon-up",
                    id: "increase-opacity"
                },
                {
                    title: "Decrease opacity",
                    className: "esri-icon-down",
                    id: "decrease-opacity"
                }
            ]
        ];
    }
    layerActionTrigger(event) {
        const selectedLayer = event.item.layer;
        const id = event.action.id;
        // if (id === "full-extent") {
        //   if(event.item.layer.spatialReference !== mapView.spatialReference){
        //     const geomSer = new GeometryService({url:
        //     "http://sampleserver6.arcgisonline.com/arcgis/rest/services/Utilities/Geometry/GeometryServer"});
        //     const params = new ProjectParameters({
        //       geometries: [event.item.layer.fullExtent],
        //       outSpatialReference: mapView.spatialReference
        //     });
        //     geomSer.project(params).then(results => {
        //       mapView.goTo(results[0]);
        //     });
        //   }else{
        //     mapView.goTo(event.item.layer.fullExtent);
        //   }
        // }
        if (id === "increase-opacity") {
            if (selectedLayer.opacity < 1) {
                selectedLayer.opacity += 0.25;
            }
        }
        if (id === "decrease-opacity") {
            if (selectedLayer.opacity > 0) {
                selectedLayer.opacity -= 0.25;
            }
        }
    }
    static ctorParameters = () => [];
};
LayerListComponent = __decorate([
    Injectable({
        providedIn: "root"
    })
], LayerListComponent);
export { LayerListComponent };
